import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  SG_FETCH_GPT_RECOMMENDATION,
  SG_ADD_GPT_RECOMMENDATION,
  SG_EDIT_GPT_RECOMMENDATION,
  SG_DELETE_GPT_RECOMMENDATION,
} from "constants/actions";
//
import {
  Icon,
  Message,
  Button,
  Header,
  List,
  Input,
  Confirm,
} from "semantic-ui-react";
//
import { format } from "date-fns";
//
import Select from "react-select";
import { BasicErrorMessage } from "utilities/ErrorMessages";

import {ReportDisplay, DataDisplay} from "./DataRender";

//
const Details = ({ employee_record_value, setReload }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [templateId, setTemplateId] = useState(false);
  const [templateDetails, setTemplateDetails] = useState({
    name: null,
  });
  const [orgSelected, setOrgSelected] = useState([]);
  const [valueSelected, setValueSelected] = useState([]);

  const [formErrors, setFormErrors] = useState([]);
  const [pristine, setPristine] = useState(true);
  const [valueChanged, setValueChanged] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  function BackArrow() {
    navigate(`/app/gpt-recommendation`);
  }

  useEffect(() => {
    setTemplateId(id);
  }, [id]);

  useEffect(() => {
    if (templateId) {
      dispatch({
        type: SG_FETCH_GPT_RECOMMENDATION,
        payload: { id: templateId },
      });
    }
  }, [dispatch, templateId]);

  const { get_gpt_recommendation } = useSelector(
    (state) => ({
      get_gpt_recommendation: state.gpt_recommendation,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (get_gpt_recommendation?.[templateId]) {
      setTemplateDetails(get_gpt_recommendation?.[templateId]);
    }
  }, [get_gpt_recommendation, templateId]);

  useEffect(() => {
    if (get_gpt_recommendation?.created?.id) {
      navigate(
        `/app/gpt-recommendation/details/${get_gpt_recommendation?.created?.id}`
      );
    }
  }, [get_gpt_recommendation, navigate]);

  useEffect(() => {
    if (get_gpt_recommendation?.deleted) {
      setReload(Math.random());
      const timer1 = setTimeout(() => {
        navigate(`/app/gpt-recommendation`);
      }, 500);
      return () => clearTimeout(timer1);
    }
  }, [get_gpt_recommendation, navigate, setReload]);

  function DeleteQuestion() {
    if (templateId) {
      dispatch({
        type: SG_DELETE_GPT_RECOMMENDATION,
        payload: {
          id: templateId,
        },
      });

      // navigate(`/app/gpt-recommendation?reload=true`)
    }
  }
  // function UpdateQuestions() {
  //   setPristine(false)
  //   if (formErrors.length === 0) {
  //     if (templateId) {
  //       dispatch({
  //         type: SG_EDIT_SURVEY_STANDARD,
  //         payload: {
  //           id: templateId,
  //           organization: orgSelected?.id,
  //           name: templateDetails?.name,
  //           replace_by: templateDetails?.replace_by,
  //           employee_record_value: valueSelected?.id,
  //         }
  //       });
  //       navigate(`/app/gpt-recommendation/detail/${templateId}`)
  //     }
  //     setPristine(true)
  //   }
  // }

  useEffect(() => {
    const ErrorList = [];
    if (!templateDetails?.name) {
      ErrorList.push("Enter a Name");
    }
    if (!valueSelected?.id) {
      ErrorList.push("Select a Value Name");
    }
    if (!orgSelected?.id) {
      ErrorList.push("Select an Organization");
    }

    setFormErrors(ErrorList);
  }, [templateDetails, valueSelected, orgSelected, valueChanged]);

  // function ChangeFormValues(e, name) {
  //   // console.log(name, e.target.value)
  //   let _ques = templateDetails
  //   _ques[`${name}`] = e.target.value
  //   setTemplateDetails(_ques)
  //   setValueChanged(e.target.value + name)
  // }

  // function ChangeDomain(e) {

  //   setValueSelected(e)
  //   setValueChanged(e)
  // }

  // function ChangeOrg(e) {
  //   setOrgSelected(e)
  //   setValueChanged(e)
  // }

  // console.log(templateDetails);

  return (
    <>
      <Header as="h2">
        <Icon
          style={{ cursor: "pointer" }}
          onClick={BackArrow}
          name="arrow left"
        />
        {templateId
          ? `View Details of ${templateDetails?.id}`
          : "Add New List Value"}
      </Header>
      {formErrors.length > 0 && !pristine && (
        <Message
          negative
          //   onDismiss={clearErrors}
          header="We need these details!"
          list={formErrors}
        />
      )}
      <SectionDiv>
        <BasicErrorMessage />
      </SectionDiv>
      {templateId && (
        <SectionDiv>
          <Container>
            <List horizontal>
              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Status</List.Header>
                    {templateDetails?.status_text}
                  </ListContainer>
                </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Tracking</List.Header>
                    {templateDetails?.tracking_code}
                  </ListContainer>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Email</List.Header>
                    {templateDetails?.email_status}
                  </ListContainer>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Updated At</List.Header>
                    {templateDetails?.created_at &&
                      format(
                        new Date(templateDetails?.updated_at),
                        "dd-MMM-yyyy hh:mm a"
                      )}
                  </ListContainer>
                </List.Content>
              </List.Item>
            </List>
          </Container>
        </SectionDiv>
      )}

      <SectionDiv>
        <DataDisplay data={templateDetails?.params} />
      </SectionDiv>
      <SectionDiv>
        <ReportDisplay data={templateDetails?.recommendation} />
      </SectionDiv>
      <SectionDiv>
        <Button floated="right" color="red" onClick={DeleteQuestion}>
          Delete
        </Button>
      </SectionDiv>
      
    </>
  );
};

export default Details;

const SectionDiv = styled.div`
  padding: 10px 0px;
  margin: 10px 0px;
  margin-bottom: ${(props) => (props.lastSection === true ? "100px" : "20px")};
`;

const Container = styled.div`
  display: flex;
`;
const SingleRowContent = styled.div`
  display: flex;
  // justify-content: flex-start;
  flex-direction: row;
`;
const SectionCell = styled.div`
  padding: 10px 10px;
  min-width: 350px;
  display: flex;
  flex-direction: row;
`;

const LabelHead = styled.label`
  font-weight: 700;
  display: block;
`;

const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`;
const FormRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5em;
`;

const FormLabel = styled.div`
  padding: 0.5em 1em 0.5em 0;
  flex: 1;
`;

const FormInput = styled.div`
  flex: 2;
`;
